import { Injectable, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EndPoint } from '@constants/api.constant';
import { IResponse } from '@models/common.model';
import { Subject, finalize, map, startWith, switchMap, tap } from 'rxjs';
import { BaseService } from './base.service';
import { OrdersService } from './orders.service';

@Injectable({
  providedIn: 'root',
})
export class CartService extends BaseService {
  orderService = inject(OrdersService);
  private reloadCart$ = new Subject<string>();
  private _cart = this.reloadCart$.pipe(
    startWith(''),
    tap(() => this._loading.set(true)),
    switchMap(() =>
      this.orderService.getCart().pipe(finalize(() => this._loading.set(false)))
    ),
    map(({ data }) => data)
  );
  private _loading = signal(false);

  private cartSignal = toSignal(this._cart);

  private _totalItem = computed(() => this.cartSignal()?.items.length ?? 0);

  loadCart() {
    this.reloadCart$.next('');
  }

  updateCartItemQuantity(productId: number, quantity: number) {
    return this.orderService
      .updateCartItemQuantity(productId, quantity)
      .pipe(finalize(() => this.loadCart()));
  }

  removeCartItem(productId: number) {
    this.orderService.removeCartItem(productId).subscribe(() => {
      this.loadCart();
    });
  }

  checkCart() {
    return this.http.get<IResponse<never>>(`${EndPoint['cartCheck'].path}`);
  }

  get cart() {
    return this.cartSignal;
  }

  get cart$() {
    return this._cart;
  }

  get loading() {
    return this._loading.asReadonly();
  }

  get totalItem() {
    return this._totalItem;
  }
}
